import classnames from 'classnames/bind';
import styles from './QuickCartControls.module.scss';
import React from 'react';
import { Skeleton } from 'gd-design-library';


const CN = 'quick-cart-controls';
const skeletonClassName = `${CN}__skeleton`;
const cx = classnames.bind(styles);

export const QuickCartControlsSkeleton: React.FC = () => (
  <>
    <Skeleton className={ cx(skeletonClassName) } width='30px' />
    <Skeleton className={ cx(skeletonClassName) } width='100%' height='40px' />
    <Skeleton className={ cx(skeletonClassName) } width='100%' height='40px' />
    <Skeleton className={ cx(skeletonClassName) } width='30px' />
    <Skeleton className={ cx(skeletonClassName) } width='100%' height='30px' />
    <Skeleton className={ cx(skeletonClassName) } width='30px' />
    <Skeleton className={ cx(skeletonClassName) } width='75px' height='40px' />
    <Skeleton className={ cx(skeletonClassName) } width='100%' height='40px' />
  </>
);
